/**
 * @generated SignedSource<<b9851c27e9da8ebb0f4ab211160a21dc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type FileType = "DOC" | "DOCX" | "PDF" | "PPT" | "PPTX" | "XLS" | "XLSX";
export type FileUploadAreaMutation$variables = {
  name?: string | null;
  type: FileType;
};
export type FileUploadAreaMutation$data = {
  readonly store: {
    readonly generateUploadLink: {
      readonly id: string;
      readonly url: string;
    };
  };
};
export type FileUploadAreaMutation = {
  response: FileUploadAreaMutation$data;
  variables: FileUploadAreaMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "name"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "type"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StoreMutations",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "name",
            "variableName": "name"
          },
          {
            "kind": "Variable",
            "name": "type",
            "variableName": "type"
          }
        ],
        "concreteType": "UploadLink",
        "kind": "LinkedField",
        "name": "generateUploadLink",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FileUploadAreaMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FileUploadAreaMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "719d8266b21e6ace06caae3bcb75e54b",
    "id": null,
    "metadata": {},
    "name": "FileUploadAreaMutation",
    "operationKind": "mutation",
    "text": "mutation FileUploadAreaMutation(\n  $name: String\n  $type: FileType!\n) {\n  store {\n    generateUploadLink(type: $type, name: $name) {\n      id\n      url\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cdf2ca85fe0b7f1ba2d4d005a20366c1";

export default node;
